import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import { TextResponseService } from '../services/text-response.service';

@Injectable()
export class TextResponseInterceptor implements HttpInterceptor {

  constructor(
    private _textResponseService: TextResponseService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this._textResponseService.applyTextResponse) {
      return next.handle(request);
    }

    request = request.clone({
      responseType: "text",
    })

    this._textResponseService.applyTextResponse = false;

    return next.handle(request);
  }
}
